/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptAnalyticsLabelKeyValueQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PromptAnalyticsLabelKeyValueQueryOperator");
    }

    getFixupPrototypeFunction() { return PromptAnalyticsLabelKeyValueQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PromptAnalyticsLabelKeyValueQueryOperator>): PromptAnalyticsLabelKeyValueQueryOperator {
        let obj = Object.assign(new PromptAnalyticsLabelKeyValueQueryOperator(), model);
        PromptAnalyticsLabelKeyValueQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptAnalyticsLabelKeyValueQueryOperator>): PromptAnalyticsLabelKeyValueQueryOperator {
        if (!model) return null;
        return PromptAnalyticsLabelKeyValueQueryOperator.newInstance(<PromptAnalyticsLabelKeyValueQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptAnalyticsLabelKeyValueQueryOperator) {
        if (!obj) return;

        models.PromptAnalyticsLabelKeyValueQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptAnalyticsLabelKeyValueQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PromptAnalyticsLabelKeyValueQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Label key to filter on
     */
    label_key: string;

    /**
     * Label values to include for the given key
     */
    label_values: Array<string>;

}
